import { TextColorToken } from '@betterment/samba-react';

export const iconNameForSymbol = (symbol: string | null | undefined) => {
  if (symbol && symbol === 'CASH_USD') {
    return 'Cash';
  }

  return 'PieAlt';
};

export const weightDisplayFor = (weight: number) => {
  const thresholdValue = 0.1;

  if (weight < thresholdValue) {
    return `<${thresholdValue.toFixed(1)}`;
  }

  return weight.toFixed(1);
};

export const textColorFor = (value: number, opts?: { allowCritical: boolean }): TextColorToken => {
  if (value > 0) return 'text.success';
  if (value < 0) return opts?.allowCritical ? 'text.critical' : 'text.weak';
  return 'text';
};

export const numberSignFor = (value: number): string => {
  return value > 0 ? '+' : '';
};

export const formattedNumberCompact = (number: number) => {
  const compactFormat = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumSignificantDigits: 3,
  });

  return compactFormat.format(number);
};
